import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';

import { configuracioGenericaGrafica, configuracioGraficaPerPeriode } from './configuracioExportacio';
import ObservacioExportacioGrafica from './observacioExportacioGrafica';
import { convertirTextAMomentUTC, MASCARA_YYYYMMDD } from '../../commons/gestioDates';


//identificadors dels periodes. S'utilitza per seleccionar la part dinàmica de la configuració de la gràfica
const periode8Hores = [1, 2, 3];    //mati, tarda, vespre
const periode24Hores = [4];         //24hores
const idVariableCobertaTotalNuvols = 45;
const idCoberturaNuvolsBaixos = 47;

/**
 * Afegeix, si cal, una serie nova al objecte "series" amb un array de dades amb valor null.
 * Això es fa per poder mostrar l'estat del cel encara que no s'estigui mostrant cap altre serie.
 * Aquesta funció no es pura.
 * @param {Object} dades
 * @param {Array} series
 */
const afegirSerieAmbDadesEnBlanc = (dades, series) => {
    //Es construeix el array de dades amb els dies i el valor a null.
    const firstKey = Object.keys(dades)[0];
    const dadesDeSerieBuida = dades[firstKey].map((elementDades) => {
        return [elementDades[0], null];
    });
    //Es mira si la serie buida ja existeix, en cas que existeix només s'han de actualitzar els valors.
    let serieAmbValorsBuits = series.find((serieElement) => {
        return serieElement.id === 0;
    });
    if (serieAmbValorsBuits) {
        //S'actualitza
        serieAmbValorsBuits.data = dadesDeSerieBuida;
    } else {
        //Sino es crea una nova
        series.push({
            data: dadesDeSerieBuida,
            showInLegend: false,
            id: 0
        });
    }
};

/**
 * Retorna un array amb els valors da "dades" i afegeix a cada valor la seva data corresponen. La data
 * vindra donada pels valors dataInici i dataFi.
 * L'array ha de tenir tantes posicions com dies hi hagi entre dataIjnici i dataFi.
 * @param {*} dataInici
 * @param {*} dataFi
 * @param {*} dades
 */
const omplirDadesAmbDates = (dataInici, dataFi, dades) => {
    const resultat = {};
    //Es preparen les series amb la data perque es poguin representar a la gràfica
    const dataIniciAsMoment = convertirTextAMomentUTC(dataInici, MASCARA_YYYYMMDD);
    const dataFiAsMoment = convertirTextAMomentUTC(dataFi, MASCARA_YYYYMMDD);

    dataIniciAsMoment.startOf('day');
    dataFiAsMoment.startOf('day');

    const numeroDeDies = dataFiAsMoment.diff(dataIniciAsMoment, 'days');

    for (let dia = 0; dia <= numeroDeDies; dia++) {
        const currentDateInMilliseconds = dataIniciAsMoment.clone().add(dia, 'days').valueOf();
        Object.keys(dades).forEach((idVariable) => {
            if (!resultat[idVariable]) {
                resultat[idVariable] = [];
            }
            let dadesVariable = dades[idVariable];

            //Es suposa que tenim el mateix número de dades que periode de consulta en dies
            resultat[idVariable][dia] = [currentDateInMilliseconds, dadesVariable[dia]];
        });
    }

    return resultat;
};

class ObservacioExportaciograficaContainer extends Component {

    /**
     * Retorna les observacions de l'estació i el període seleccionat. Es retorna un array amb tantes
     * posicions com dies del periode dataInici i dataFi. A cada observació se li asocia la seva data en milisegons.
     * nú
     *
     * @param {String} nomPeriode
     * @param {String} nomEstacio
     */
    estructurarDadesObservacions(dataInici, dataFi, dades) {
        const dadesAmbDates = omplirDadesAmbDates(dataInici, dataFi, dades);

        return dadesAmbDates;
    }

    actualitzarConfiguracioGrafica(nomEstacio, nomPeriode, dades) {
        let observacionsVariableCel;
        const { periodeSeleccionat } = this.props;

        const configuraPeriodeSeleccionat = this.getConfiguraciograficaPerPeriode(periodeSeleccionat);
        if (!configuraPeriodeSeleccionat) return;

        //Si no hi han dades es retorna la configuració base de la gràfica, sense series ni eixos.
        if (!dades) {
            return {
                ...configuracioGenericaGrafica,
                title: { text: nomEstacio },
                subtitle: { text: 'Període: ' + nomPeriode }
            };
        }

        //Si te variables del cel s'han de posar a les options fora de les series per poder dibuixar els icones.
        //Les variables del cel no utilitzen les series perque no son part de la gràfica
        if (dades[idVariableCobertaTotalNuvols] || dades[idCoberturaNuvolsBaixos]) {
            observacionsVariableCel = {
                coberturaTotal: dades[idVariableCobertaTotalNuvols],
                nuvolsBaixos: dades[idCoberturaNuvolsBaixos]
            };
        }

        //Afegim dades a les series
        Object.keys(dades).forEach((idVariableAsString) => {
            const idVariable = Number(idVariableAsString);
            //Es busca la serie
            let serie = configuraPeriodeSeleccionat.series.find((serie) => {
                return serie.id === idVariable;
            });

            if (serie) {
                serie.data = dades[idVariable];
            }
        });

        return {
            ...configuracioGenericaGrafica,
            ...configuraPeriodeSeleccionat,
            title: { text: nomEstacio },
            subtitle: { text: 'Període: ' + nomPeriode },
            observacionsVariableCel,

            /**
             * Inici Workaround per solventar problema amb l'iPad
             * Veure: https://github.com/highcharts/highcharts/issues/8520
             */
            chart: {
                events : {
                    load: function() {
                        var chart = this,
                            className = 'highcharts-contextmenu';

                        chart.exportEvents.push(Highcharts.addEvent(document, 'touchstart', function(e) {
                            var menu = chart['cache-' + className];
                            if (menu && !chart.pointer.inClass(e.target, className) && !chart.pointer.inClass(e.target, 'highcharts-contextbutton')) {
                                Highcharts.css(menu, {display: 'none'});
                                chart.openMenu = false;
                                chart.exportSVGElements[0].setState(0);
                            }
                        }));
                    }
                }
            }
            /**
             * Fi Workaround per solventar problema amb l'iPad
             * Veure: https://github.com/highcharts/highcharts/issues/8520
             */
        };
    }

    /**
     * Retorna la configuració per la gràfica segons el periode seleccionat. El periode pot ser de 24h o cada 8h.
     * Es podria fer de moltes maneres, per simplicar, si es
     * @param {number} idPeriode id del periode seleccionat.
     */
    getConfiguraciograficaPerPeriode(idPeriode) {
        const id = (typeof idPeriode !== 'number') ? Number(idPeriode) : idPeriode;

        if (periode8Hores.indexOf(id) !== -1) {
            return configuracioGraficaPerPeriode()['8h'];
        }

        if (periode24Hores.indexOf(id) !== -1) {
            return configuracioGraficaPerPeriode()['24h'];
        }

        return null;
    }

    render() {
        const { nomPeriode, nomEstacio, dades, dataInici, dataFi } = this.props;

        //Configuracio de la grafica
        const dadesEstructurades = this.estructurarDadesObservacions(dataInici, dataFi, dades);
        const configuracioGrafica = this.actualitzarConfiguracioGrafica(nomEstacio, nomPeriode, dadesEstructurades);

        //Afegim una serie de dades en blanc
        if (!dadesEstructurades || !configuracioGrafica) return null;
        afegirSerieAmbDadesEnBlanc(dadesEstructurades, configuracioGrafica.series);

        return (
            <div>
                <ObservacioExportacioGrafica options={configuracioGrafica} />
            </div>
        );
    }
}

ObservacioExportaciograficaContainer.propTypes = {
    dataInici: PropTypes.string,
    dataFi: PropTypes.string,
    nomPeriode: PropTypes.string,
    nomEstacio: PropTypes.string,
    dades: PropTypes.object,
    periodeSeleccionat: PropTypes.string
};


export default ObservacioExportaciograficaContainer;



// WEBPACK FOOTER //
// ./src/components/observacio/observacioExportacioGraficaContainer.js